import notification from 'app/config/notification';

export const errorHandler = (status, message) => {
  let msg = message;
  let errorType = 'error';
  // eslint-disable-next-line default-case
  switch (status) {
    case 401: //Unauthorized
    case 403: //Forbidden
      msg = null;
      errorType = 'warning';
      break;

    case 400: //Bad Request
    case 405: //Method Not Allowed
    case 413: //Payload Too Large
      msg =
        'Problemas com as informações enviadas. Entre em contato com o administrador do sistema.';
      break;

    case 404: //Not Found
    case 408: //Request Timeout
    case 502: //Bad Gateway
    case 503: //Service Unavailable
    case 504: //Gateway Timeout
      msg = 'Erro de comunicação. Tente novamente.';
      break;
  }

  if (msg != null) {
    notification(msg, {
      toastId: 'SERVER_ERROR',
      type: errorType,
    });
  }
};

export const ignoreErrorHandler = [
  '/user/login'
]
